<template>
  <div>
    <div class="vx-row mb-4 mt-5">
      <!-- Analista Responsável Reparo -->
      <div class="vx-col xl:w-1/2 w-full mb-2">
        <label for="" class="vs-select--label"
          >Analista Responsável Reparo:</label
        >
        <v-select
          class="selectStyle"
          :options="listResponsaveis"
          name="Responsável"
          id="Responsável"
          v-model="formDadosReparo.idUsuario"
          label="label"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
        ></v-select>
      </div>

      <!-- Sicronizar Eventos Cilia -->
      <div class="vx-col xl:w-1/2 w-full mb-2">
        <label for class="vs-input--label">Sincronizar Eventos Cilia</label>
        <vs-switch
          v-model="formDadosReparo.sincronizarCilia"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
    </div>

    <!-- Observações Controle Interno -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-textarea
          label="Descrição do Evento para controle interno"
          v-model="formDadosReparo.descricaoEventoControleInterno"
        />
      </div>
    </div>

    <!-- Observações -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <span class="vs-input--label">Observações</span>
        <vue-editor
          v-model="formDadosReparo.observacao"
          :editor-toolbar="customToolbar"
        ></vue-editor>
      </div>
    </div>

    <HistoricoObservacao :historicos="formDadosReparo.historicos" />
  </div>
</template>

<script>
import HistoricoObservacao from './../../../../shared/components/HistoricoObservacao.vue';
import vSelect from 'vue-select';
import { VueEditor } from 'vue2-editor';
import customToolbar from './../../../../../../../components/editor/config';

export default {
  props: ['formData', 'dominios'],
  watch: {
    formData(value) {
      if (!value.dadosReparo) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - REPARO VEICULO FORM');
        return;
      }

      this.formDadosReparo = Object.assign(
        this.formDadosReparo,
        value.dadosReparo,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.dadosReparo = this.formDadosReparo;
    },
  },
  components: {
    HistoricoObservacao,
    vSelect,
    VueEditor,
  },
  data() {
    return {
      showComponent: true,
      formDadosReparo: {
        idUsuario: null,
        sincronizarCilia: null,
        descricaoEventoControleInterno: null,
        observacao: null,
        historicos: [],
      },
      listResponsaveis: [],

      // Configurações de Component
      customToolbar,
    };
  },
  methods: {},
  mounted() {
    if (!this.formData.dadosReparo) {
      console.error('ERRO NO CONTRATO DO OBJETO - REPARO VEICULO FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.dadosReparo = this.formDadosReparo;

    this.listResponsaveis = this.dominios.listResponsaveis;
  },
};
</script>
<style scoped>
.selectStyle {
  font-size: 1rem !important;
}
</style>

<style src="./../../../../../../../components/editor/style-editor.css"></style>
